import UntrackedModel from "./untracked/untrackedModel";
import {RoleType} from "../enums/roles/roleType";
import {IRoleGeneral} from "../interfaces/roleInterfaces";

export default class Role extends UntrackedModel implements IRoleGeneral {
  capabilities: number[] = [];
  id: string;
  is_permanent: boolean;
  member_count: number;
  name: string;
  role_type: RoleType;
  _metadata: {has_members?: boolean};
  except: string[] = ['member_count', '_metadata'];

  static get displayName(): string {
    return 'Role';
  }

  get hasMembers(): boolean {
    return this.member_count > 0 || this._metadata.has_members; // could have an actually count or short-circuited boolean value
  }
}